import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "version-1100--major"
    }}>{`Version: 11.0.0 : Major`}</h2>
    <h4 {...{
      "id": "xxxxxxxxxxxxxxxx"
    }}>{`xxxxxxxxxxxxxxxx`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Caution! Breaking Changes! see all breaking change list `}<a parentName="p" {...{
          "href": "/breaking-changes"
        }}>{`All Breaking Changes`}</a></p>
    </blockquote>
    <pre><code parentName="pre" {...{}}>{`- [Enhancement] & [Shop end] Two new demos.
- [Enhancement] & [Shop end] One new product grid for flash deals.
- [Enhancement] & [Shop end] Pickbazar shop design facelift
- [Enhancement] & [Shop end] Pickbazar shop Menu items updated
- [Enhancement] & [Shop end] Pickbazar shop Footer updated
- [Enhancement] Pickbazar admin dashboard design facelift
- [Enhancement] Pickbazar vendor & Staff dashboard design facelift
- [Enhancement] Settings page is divided into multi parts.
- [Enhancement] User section divided into multiple layer for better management.
- [Enhancement] Shop section divided into multiple layer for better management.
- [Enhancement] Products section divided into multiple layer for better management.
- [Enhancement] Settings cache system for performance optimization.
- [Enhancement] Documentation updated    
- [Enhancement] Database seeder added
    - Settings seeder with Console command 
    - Demo FAQs seeder 
    - Demo refund reason & policy seeder

- [New Feature] Dashboard analytics section updated along with new analytics widgets
- [New Feature] Product Preview system added.
- [New Feature] Flash sale builder added
- [New Feature] Terms & Condition builder added
    - Super admin can perform CRUD operation
    - Vendor also can perform CRUD operation if and only if super admin enable this feature from settings.
- [New Feature] FAQs builder added
    - Super admin can add FAQs for global scope
    - Vendor can add FAQs based on his each shop
- [New Feature] Refund policy builder added
- [New Feature] Refund reason builder added.
- [New Feature] Product inventory route added
- [New Feature] Order transaction route added.
- [New Feature] Real-time notification system using Pusher
    - Order notification
    - Message notification
    - Store notice notification 
- [New Feature] New filter option added in different routes
- [New Feature] New Dashboard topbar 
    - With route searching
    - Shop redirection & creating
    - Order, Store notice & messaging dropdown bar 
    - New Profile navigation

- [Issue fix] Variable products issue fix on digital item
- [Issue fix] Route permission issue fix for Vendor & staff
- [Issue fix] Analytics issue fix on Staff user
- [Issue fix] Drafted product republish issue fix
- [Issue fix] Vendor page profile information issue fix
- [Issue fix] Currency cache issue fix
- [Issue fix] Product carting count issue based on available inventory
- [Issue fix] Messege converstation page CSS issue fix
- [Issue fix] Vendor root page shop grid issue fix    
- [Issue fix] Variable product inventory increment/decerement issue fix based on ordering.
- [Issue fix] Application fresh installation issue fix.
- [Issue fix] OpenAI chatbot suggestion issue fix.
- [Issue fix] Order status issue fix during order from different vendor
- [Issue fix] Customer order details payment and order status fix in case of refund    
- [Issue fix] Toast issue fix throughout the dashboard & shop project
- [Issue fix] User order note issue fix 
- [Issue fix] Site logo issue fix
- [Issue fix] Minimum order amount issue fix
- [Issue fix] Multilingual issue fix for some text strings 
- [Issue fix] CSS issue fix throughout the shop end
`}</code></pre>
    <h2 {...{
      "id": "version-1060"
    }}>{`Version: 10.6.0`}</h2>
    <h4 {...{
      "id": "28-august-2023"
    }}>{`28 August 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [Enhancement] Added currency in the exported Order Excel sheet 
- [Enhancement] Modified Order details in both shop and admin panel
- [Issue Fix] Partial Wallet Payment 
- [Issue Fix] Customer product review
- [Issue Fix] Send notification when order status changes 
- [Issue Fix] Sorting and filtering issue fix for both Rest and Graphql
`}</code></pre>
    <h2 {...{
      "id": "version-1050"
    }}>{`Version: 10.5.0`}</h2>
    <h4 {...{
      "id": "17-august-2023"
    }}>{`17 August 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New Feature] Shop Address autocomplete using Google map 
- [Enhancements] External Product feature enhancements 
- [Enhancements] International slug support added
- [Issue Fix] Import Export issue fixed
- [Issue Fix] Refund issue fixed
- [Issue Fix] Coupon date picker bug fixed 
`}</code></pre>
    <h2 {...{
      "id": "version-1040"
    }}>{`Version: 10.4.0`}</h2>
    <h4 {...{
      "id": "24-july-2023"
    }}>{`24 July 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New Feature] Google Maps find or Search Nearby shops
- [Issue Fix] Development mode build issue fixed
- [Issue Fix] Graphql playground issue fixed
- [Issue Fix] International Slug Generate Issue Fixed
`}</code></pre>
    <h2 {...{
      "id": "version-1030"
    }}>{`Version: 10.3.0`}</h2>
    <h4 {...{
      "id": "12-july-2023"
    }}>{`12 July 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New Feature] Stripe Element support added 
- [New Feature] Making sku unique
- [Issue Fix] Admin place order GraphQL
- [Issue Fix] FullWallet payment 
- [Issue Fix] Change Payment Gateway as Guest user 
- [Issue Fix] Admin File validation 
- [Issue Fix] Wishlist Issue Graphql 
- [Issue Fix] Full Order Details based on User Role
- [Issue Fix] Store notice
`}</code></pre>
    <h2 {...{
      "id": "version-1020"
    }}>{`Version: 10.2.0`}</h2>
    <h4 {...{
      "id": "13-june-2023"
    }}>{`13 June 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New Feature] Added Flutterwave Payment Gateway
- [New Feature] Added Flutterwave Configure Documentation.
- [Enhancements] User Documentation added(Question,Review,Withdrawals,Coupon,Tax & Shipping)
`}</code></pre>
    <h2 {...{
      "id": "version-1010"
    }}>{`Version: 10.1.0`}</h2>
    <h4 {...{
      "id": "30-may-2023"
    }}>{`30 May 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New Feature] Added Paymongo Payment Gateway
- [New Feature] Added bKash Payment Gateway
`}</code></pre>
    <h2 {...{
      "id": "version-1000-major"
    }}>{`Version: 10.0.0 Major`}</h2>
    <h4 {...{
      "id": "15-may-2023"
    }}>{`15 May 2023`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Caution! Breaking Changes! see all breaking change list `}<a parentName="p" {...{
          "href": "/breaking-changes"
        }}>{`All Breaking Changes`}</a></p>
    </blockquote>
    <pre><code parentName="pre" {...{}}>{`- [New Feature] Set SMS Events from settings for Admin, Vendor & Customer. 
- [New Feature] Set Email Event from settings for Admin, Vendor & Customer. 
- [New Feature] Email Event Setting option 
- [New Feature] SMS Settings for both Graphql and REST
- [New Feature] Added Setting Seeder
- [New Feature] New Console Command marvel:settings_seed
- [New Feature] Added Settings Dummy data seeder command
- [New Feature] Added OpenAI support in every possible description,
    - Create Shop → Description, 
    - Create Manufacturer/Publication → Description,
    - Create New Category → Details,
    - Create Tag → Details, 
    - Create Author → Bio, 
    - Create Author → Quote, 
    - Create New Coupon → Bio,
    - Create New Coupon → Description,
    - Settings → Meta Description, 
    - Settings → OG Description
- [Enhancement] Added Video attribute for a product. 
- [Enhancement] Order cancel Recalculate
- [Enhancement] Order Note attribute added for Order
- [Enhancement] Guest Checkout Enable/Disable option on setting
- [Enhancement] Video Preview in Single Product view page
- [Issue Fix] Handled Unused Order Creation and other minor
- [Issue Fix] Fixed Settings issue.
- [Issue Fix] Search Page redirection issue fixed.
- [Issue Fix] Next router URL issue fixed on search component
- [Issue Fix] Homepage control issue fixed
`}</code></pre>
    <h2 {...{
      "id": "version-910"
    }}>{`Version: 9.1.0`}</h2>
    <h4 {...{
      "id": "15-may-2023-1"
    }}>{`15 May 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New Feature] OpenAI integration added.
- [New Feature] Generate product description with AI.
- [New Feature] Generate store notice with AI.
- [New Feature] Predefined prompt suggestions with appropriate tone for both product description and store notice.
- [New Feature] Added Country wise currency formation  support
`}</code></pre>
    <h2 {...{
      "id": "version-900-major"
    }}>{`Version: 9.0.0 Major`}</h2>
    <h4 {...{
      "id": "2-may-2023"
    }}>{`2 May 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Multiple payment gateway management 
- [New feature] Product publish management control [new feature]
- [New feature] Best selling product [new feature]
- [Enhancement] New color scheme for order status 
- [Enhancement] Payment modal steps modified
- [issue fix] Product sale price 
- [issue fix] Multi-language auto translation
- [issue fix] Related product
- [issue fix] product out-of-stock quantity
- [issue fix] Backend order status GraphQL
- [issue fix] Unpublished/hidden product add-to-cart
`}</code></pre>
    <h2 {...{
      "id": "version-820"
    }}>{`Version: 8.2.0`}</h2>
    <h4 {...{
      "id": "3-april-2023"
    }}>{`3 April 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Added Xendit (Southeast Asia) payment gateway
- [New feature] Added Iyzico (turkish) Payment Gateway
- [New feature] Added Email verification for all user and 
- [New feature] Added Must verify email switch in the setting
- [Enhancement] Re-organized Exception handling for proper Rest status code
`}</code></pre>
    <h2 {...{
      "id": "version-810"
    }}>{`Version: 8.1.0`}</h2>
    <h4 {...{
      "id": "21-march-2023"
    }}>{`21 March 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Added Paystack Payment Gateway
- [New feature] Added SSLCOMMERZ Payment Gateway
- [issue fix] Fixed Default Card Issue
`}</code></pre>
    <h2 {...{
      "id": "version-800-major"
    }}>{`Version: 8.0.0 Major`}</h2>
    <h4 {...{
      "id": "15-march-2023"
    }}>{`15 March 2023`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Caution! Breaking Changes! see all breaking change list `}<a parentName="p" {...{
          "href": "/breaking-changes"
        }}>{`All Breaking Changes`}</a></p>
    </blockquote>
    <pre><code parentName="pre" {...{}}>{`- [System Upgrade] Upgraded Pickbazar API to Laravel 10 & all other packages
- [System Upgrade] Upgraded Pickbazar Admin to Next JS 13 & all other packages
- [System Upgrade] Upgraded Pickbazar Shop to Next JS 13 & updated all other packages
- [issue fix] Fixed permission issue
- [issue fix] Fixed Slug issue
`}</code></pre>
    <h2 {...{
      "id": "version-700-major"
    }}>{`Version: 7.0.0 Major`}</h2>
    <h4 {...{
      "id": "february-2023"
    }}>{`February 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Add Admin dashboard store notice CRUD  for specific vendor/ All 
- [New feature] Add Vendor profile store notice list with read unread feature
- [New feature] Add Staff profile store notice list with read unread feature
- [New feature] Add Vendor Shop dashboard store notice CRUD
- [New feature] Add Store notice in shop for customer.
- [New feature] Add google map autocomplete address form
- [New feature] Add useGoogleMap switch in settings
- [New feature] Add Dashboard Menu message for admin , store owner and staff
`}</code></pre>
    <h2 {...{
      "id": "version-631"
    }}>{`Version: 6.3.1`}</h2>
    <h4 {...{
      "id": "9-january-2023"
    }}>{`9 January 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [issue fix] Minimum order amount calculation issue fix shop & admin
- [Enhancement] Razorpay Documentation added.
`}</code></pre>
    <h2 {...{
      "id": "version-630"
    }}>{`Version: 6.3.0`}</h2>
    <h4 {...{
      "id": "22-december-2022"
    }}>{`22 December 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Added Mollie payment gateway
- [New feature] Added percentage, free-shipping coupon option
- [New feature] Added automatic free-shipping coupon option
- [New feature] Added option to set minimum amount for coupon
- [Enhancement] Display customer name for guest checkout
`}</code></pre>
    <h2 {...{
      "id": "version-620"
    }}>{`Version: 6.2.0`}</h2>
    <h4 {...{
      "id": "12-december-2022"
    }}>{`12 December 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Added RazorPay (India) payment gateway
- [New feature] Added name input options for guest checkout
- [issue fix] Fixed single-order issue
- [issue fix] Fixed maximum question limit issue  
`}</code></pre>
    <h2 {...{
      "id": "version-610"
    }}>{`Version: 6.1.0`}</h2>
    <h4 {...{
      "id": "8-december-2022"
    }}>{`8 December 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Added RazorPay (India) payment gateway
- [New feature] Added name input options for guest checkout
- [issue fix] Fixed single-order issue
- [issue fix] Fixed maximum question limit issue 
`}</code></pre>
    <h2 {...{
      "id": "version-600-major"
    }}>{`Version: 6.0.0 Major`}</h2>
    <h4 {...{
      "id": "16-november-2022"
    }}>{`16 November 2022`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Caution! Breaking Changes! see all breaking change list `}<a parentName="p" {...{
          "href": "/breaking-changes"
        }}>{`All Breaking Changes`}</a></p>
    </blockquote>
    <pre><code parentName="pre" {...{}}>{`- [System Upgrade] Upgrade API to laravel 9
- [Enhancement] Restructure the entire payment gateway system
- [New feature] Added Stripe (Intent Based) and PayPal payment gateway
- [New feature] Added card management feature
- [Enhancement] Removed omnipay packages
- [New feature] Added support for status-based inventory management option
- [New feature] Added balance dispatch option based on status
- [New feature] Added option to disable cash on delivery system
- [New feature] Added product slug edit feature
- [issue fix] Fixed docker zip extension issue
- [issue fix] Fixed wallet points order issue
- [issue fix] Fixed order fail issue
- [issue fix] Fixed excel package cache issue
- [issue fix] Fixed user block and vendor inactive issue
- [issue fix] Fixed blank order created issue
- [issue fix] Fixed repeated new user wallet add issue for OTP login
- [issue fix] Fixed negative subtotal for coupon
`}</code></pre>
    <h2 {...{
      "id": "version-501"
    }}>{`Version: 5.0.1`}</h2>
    <h4 {...{
      "id": "16-august-2022"
    }}>{`16 August 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [issue fix] Fixed dashboard recent withdraw issue
- [issue fix] Fixed vendor item edit path issue
- [issue fix] Fixed translation text issue
- [issue fix] Fixed add new address issue at backend booking
- [issue fix] Fixed admin profile image update issue
- [issue fix] Fixed composer v2 package installation issue
- [issue fix] Fixed category filter issue
- [issue fix] Fixed backend order address responsive issue
`}</code></pre>
    <h2 {...{
      "id": "version-500-major"
    }}>{`Version: 5.0.0 Major`}</h2>
    <h4 {...{
      "id": "7th-july-2022"
    }}>{`7th July 2022`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Caution! Breaking Changes! see all breaking change list `}<a parentName="p" {...{
          "href": "/breaking-changes"
        }}>{`All Breaking Changes`}</a></p>
    </blockquote>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Multilingual support added
- [New feature] Added toast notification after payment confirmation
- [issue fix] Fixed invoice issue for Unicode language
- [issue fix] Fixed wallet issue for social login
- [issue fix] Fixed file upload security issue
- [issue fix] Fixed book demo search page broken issue
- [issue fix] Fixed few minor bugs
`}</code></pre>
    <h2 {...{
      "id": "version-460"
    }}>{`Version: 4.6.0`}</h2>
    <h4 {...{
      "id": "18th-april-2022"
    }}>{`18th April 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Introduced order export support
- [New feature] Introduced my question page
- [New feature] Introduced my report page
- [New feature] Added variation support for review
- [New feature] Added question rate limit option
- [New feature] Added email notification for questions
- [New feature] Added support for auto remove review after refund
- [New feature] Added support for fixed report limit
- [issue fix] Fixed review bugs
- [issue fix] Fixed zip upload placeholder issue
- [issue fix] Fixed logout issue for mobile device
- [issue fix] Fixed export-import issue
`}</code></pre>
    <h2 {...{
      "id": "version-451"
    }}>{`Version: 4.5.1`}</h2>
    <h4 {...{
      "id": "1st-april-2022"
    }}>{`1st April 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [issue fix] Fixed category create issue
- [issue fix] Fixed OTP form issue
- [issue fix] Fixed feedback issue
- [issue fix] Fixed route issue
`}</code></pre>
    <h2 {...{
      "id": "version-450"
    }}>{`Version: 4.5.0`}</h2>
    <h4 {...{
      "id": "1st-march-2022"
    }}>{`1st March 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Introduced Review support for products
- [New feature] Introduced Report abusive review
- [New feature] Introduced Review Feedback
- [New feature] Introduced Question and Answer support for products
- [New feature] Introduced Q&A Feedback
- [New feature] Introduced Wishlist support
- [New feature] Introduced My wishlist page
- [issue fix] Fixed withdraw form balance issue
- [issue fix] Order Page selection issue fixed
- [issue fix] Packages version is locked to a fixed version
- [issue fix] Safari and Firefox scroll issue fixed
- [Enhancement] Out of stock notice
`}</code></pre>
    <h2 {...{
      "id": "version-442"
    }}>{`Version: 4.4.2`}</h2>
    <h4 {...{
      "id": "17th-february-2022"
    }}>{`17th February 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [System Upgrade] Upgrade shop component to tailwind 3
- [System Upgrade] Upgrade shop packages
- [issue fix] Fixed a few minor bugs 
`}</code></pre>
    <h2 {...{
      "id": "version-441"
    }}>{`Version: 4.4.1`}</h2>
    <h4 {...{
      "id": "17th-january-2022"
    }}>{`17th January 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Guest checkout support provided
- [New feature] Enable/Disable OTP in checkout option in admin settings
- [Enhancement] Restructured order details page.
`}</code></pre>
    <h2 {...{
      "id": "version-440"
    }}>{`Version: 4.4.0`}</h2>
    <h4 {...{
      "id": "10th-january-2022"
    }}>{`10th January 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Digital Product support for both simple and variable product
- [New feature] New Book Demo introduced for digital download
- [New feature] Digital checkout page introduced
- [New feature] New search page introduced
- [New feature] Email newsletter subscription
- [New feature] Digital file download option
- [New feature] Backend order support
- [New feature] Variation specific image support
- [New feature] External product support
- [New feature] Author and Manufacturer support for products
- [Enhancement] Author and Manufacturer Archive page
- [Enhancement] Author and Manufacturer details page
- [Issue Fix] Rest vendor permission issue fixed
- [Issue Fix] Super admin role user creation issue fixed
`}</code></pre>
    <h2 {...{
      "id": "version-430"
    }}>{`Version: 4.3.0`}</h2>
    <h4 {...{
      "id": "25th-october-2021"
    }}>{`25th October 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [Issue Fix] Fixed rest home page query issue
- [Issue Fix] Fixed admin product edit issue
- [Issue Fix] Fixed iOS issue
`}</code></pre>
    <h2 {...{
      "id": "version-420"
    }}>{`Version: 4.2.0`}</h2>
    <h4 {...{
      "id": "18th-october-2021"
    }}>{`18th October 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Wallet points
- [New feature] Refunds using wallet points
- [New feature] Signup wallet points
`}</code></pre>
    <h2 {...{
      "id": "version-410"
    }}>{`Version: 4.1.0`}</h2>
    <h4 {...{
      "id": "4th-october-2021"
    }}>{`4th October 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Introduced new Layout(Daily Needs)
- [Enhancement] Moved sorting to table column in admin
- [Issue Fix] Added few missing translation
`}</code></pre>
    <h2 {...{
      "id": "version-400-major"
    }}>{`Version: 4.0.0 Major`}</h2>
    <h4 {...{
      "id": "26th-august-2021"
    }}>{`26th August 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [Enhancement] Folder structure changed
- [Enhancement] api namespaces and prefix changed
- [Enhancement] Changed console command prefix to "marvel" 
- [Enhancement] Updated doc
- [Issue Fix] Delivery time selection bug fixed
- [Issue Fix] Rest order creation bug fixed
`}</code></pre>
    <h2 {...{
      "id": "version-300-major"
    }}>{`Version: 3.0.0 Major`}</h2>
    <h4 {...{
      "id": "22-august-2021"
    }}>{`22 August 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [System Upgrade] Updated necessary packages to latest version
- [Enhancement] Restructured shop code
- [New feature] Added layout changing option in admin
- [New feature] Added group based layout system
- [New feature] Dynamic promotional slider
- [New feature] Type based promotional slider
- [New feature] Single checkout page
- [New feature] Added dynamic homepage selection settings 
- [New feature] added contact details for admin in settings
- [Issue Fix] Fixed cart update check availability issue
- [Issue Fix] Fixed color picker issue in order status form
- [Issue Fix] Fixed staff delete issue
- [Issue Fix] Fixed Inactive shop orders page issue
- [Issue Fix] Order details rest variable product title issue fixed
- [Issue Fix] Missing translation updated
- [Issue Fix] Minor css fix
`}</code></pre>
    <h2 {...{
      "id": "version-231"
    }}>{`Version: 2.3.1`}</h2>
    <h4 {...{
      "id": "3rd-august-2021"
    }}>{`3rd August 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [Issue Fix] mobile navigation issue in admin
- [Issue Fix] cart update checkout data
- [Issue Fix] analytics data issue
`}</code></pre>
    <h2 {...{
      "id": "version-230"
    }}>{`Version: 2.3.0`}</h2>
    <h4 {...{
      "id": "2nd-august-2021"
    }}>{`2nd August 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] product import export
- [New feature] minimum order amount 
- [Issue Fix] env issue foxed for API 
- [Issue Fix] rest draft product issue 
- [Issue Fix] group delete issue fixed 
`}</code></pre>
    <h2 {...{
      "id": "version-220"
    }}>{`Version: 2.2.0`}</h2>
    <h4 {...{
      "id": "18th-july-2021"
    }}>{`18th July 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] OTP Login
- [New feature] OTP verification in profile contact 
- [New feature] OTP verification in checkout customer contact
- [New feature] Added group banner adding an option in the admin dashboard
- [New feature] Dynamic delivery time added in settings. 
- [Enhancement] Stripe latest API version support with token
- [Enhancement] Vendor email notification
- [Enhancement] Restructured checkout procedure
- [Enhancement] Minor design improvement
`}</code></pre>
    <h2 {...{
      "id": "version-210"
    }}>{`Version: 2.1.0`}</h2>
    <h4 {...{
      "id": "8th-july-2021"
    }}>{`8th July 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Added Sorting for dashboard listing pages
- [New feature] Added Filtering for product and category in the admin dashboard
- [New feature] Added shop location and settings
- [New feature] Added google places autocomplete
- [Enhancement] Minor design improvement
- [Issue Fix] Fixed SSR issue in the shop
- [Issue Fix] Fixed shop single page not found issue
`}</code></pre>
    <h2 {...{
      "id": "version-201"
    }}>{`Version: 2.0.1`}</h2>
    <h4 {...{
      "id": "3rd-july-friday-2021"
    }}>{`3rd July Friday 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [Issue Fix] Fixed "Invalid Version: 2.0" issue
`}</code></pre>
    <h2 {...{
      "id": "version-200-major"
    }}>{`Version: 2.0.0 Major`}</h2>
    <h4 {...{
      "id": "1st-july-wednesday-2021"
    }}>{`1st July Wednesday 2021`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Caution! Breaking Changes! see all breaking change list `}<a parentName="p" {...{
          "href": "/breaking-changes"
        }}>{`All Breaking Changes`}</a></p>
    </blockquote>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Multivendor support
- [New feature] Single owner multiple shop
- [New feature] Withdraws
- [New feature] Order Management
- [New feature] Shop Management
- [New feature] Staff Management
- [New feature] Product Management
- [New feature] Attribute Management
- [New feature] Shop Archives
- [New feature] Shop details
- [New feature] Internationalization support with RTL
- [New feature] Product Tags support
`}</code></pre>
    <h2 {...{
      "id": "version-130"
    }}>{`Version: 1.3.0`}</h2>
    <h4 {...{
      "id": "16th-june-wednesday-2021"
    }}>{`16th June Wednesday 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [Issue Fix] Product adding fix for rest api
- [Issue Fix] cart item delete fix for rest api 
`}</code></pre>
    <h2 {...{
      "id": "version-120"
    }}>{`Version: 1.2.0`}</h2>
    <h4 {...{
      "id": "9th-june-2021"
    }}>{`9th June, 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Added social authentication [ facebook & google ]
- [Issue Fix] Fixed password mismatched issue
- [Issue Fix] Fixed GraphQL admin product display issue
- [Issue Fix] Fixed GraphQL env issue
- [Issue Fix] Fixed few minor bugs 
`}</code></pre>
    <h2 {...{
      "id": "version-110"
    }}>{`Version: 1.1.0`}</h2>
    <h4 {...{
      "id": "10th-may-monday-2021"
    }}>{`10th May Monday 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [New feature] Variable Product support added
- [New feature] invoice download option added
- [New feature] SEO settings added
- [New feature] New modal layout design
- [New feature] New product single page layout design
`}</code></pre>
    <h2 {...{
      "id": "version-101"
    }}>{`Version: 1.0.1`}</h2>
    <h4 {...{
      "id": "thursday-22-april-2021"
    }}>{`Thursday 22 April 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- [Issue Fix] Fixed rest admin child product select issue
`}</code></pre>
    <h2 {...{
      "id": "version-100"
    }}>{`Version: 1.0.0`}</h2>
    <h4 {...{
      "id": "thursday-14-april-2021"
    }}>{`Thursday 14 April 2021`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Initial release.
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      